// extracted by mini-css-extract-plugin
export default {"table":"MyTeamsTable_table__f5Btm","row":"MyTeamsTable_row__N3n8Y","text":"MyTeamsTable_text__aPlit","actions":"MyTeamsTable_actions__q+S2t"};